export default __webpack_public_path__ + "static/media/en_order_01.dd957bd9.png";